export const AppState = {
    isLoggedIn: false,
    userDetails: {},
    isAuthForCourse: false,
    courseId: null
}

export default AppState;